export default __webpack_public_path__ + "static/media/cartao-mais-infancia.1a40b916.jpg";